<template>
  <div class="contact">
    <div class="MainOne">
      <img
        src="../assets/image/产品详情.png"
        alt="产品详情"
        style="height: 490px"
      />
    </div>
    <div class="MainTwo">
      <div style="width: 100%; margin: 0 auto">
        <div class="right_letter">打破常规，创新无限！</div>
      </div>
      <h2>产品详情</h2>
      <h3>Product details</h3>
      <el-row :gutter="60">
        <div
          class="grid-content"
          style="height: auto; margin: 0 auto; width: 40%; margin-bottom: 30px"
        >
          <img
            :src="dataProduct.url"
            alt=""
            style="width: 100%; height: auto"
          />
        </div>
      </el-row>
      <div class="grid-content bg-purple-light">
        <div class="right_1" style="background-color: #1697be; color: #fff">
          <div class="right_bottom_1">
            <div class="img">{{ dataProduct.productName }}</div>
            <div class="model">{{ dataProduct.productModel }}</div>
          </div>
          <div class="des">
            {{ dataProduct.productIntro }}
          </div>
          <div class="bottom_all">
            <div class="pho_all">
              <div>
                <img
                  src="../assets/image/手机(1).png"
                  alt="手机"
                  style="width: 50px; height: 50px; margin-bottom: -11px"
                />
              </div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-direction: column;
                  color: #333;
                "
              >
                <div class="Consultation_Hotline">咨询热线：</div>
                <div class="phone">18912720358</div>
              </div>
            </div>
            <router-link to="/ContactUs">
              <div class="con_all">
                <div>
                  <img
                    src="../assets/image/电话(2).png"
                    alt="电话"
                    style="width: 50px; height: 50px"
                  />
                </div>
                <div class="contact_us">联系我们</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <h2 style="margin-top: 60px">产品参数</h2>
      <h3 style="margin-bottom: 30px">Product Parameters</h3>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="parameterName" label="技术参数" width="300px">
        </el-table-column>
        <el-table-column prop="data" label="值"> </el-table-column>
      </el-table>

      <h3 style="margin-bottom: 30px; margin-top: 40px">
        产品厂家：江苏君成智慧洁净科技有限公司。
      </h3>
      <h3 style="margin-bottom: 30px">服务热线：18100681818（微信同）。</h3>
      <h3 style="margin-bottom: 30px">官网：www.jcgyzn.com</h3>
    </div>
  </div>
</template>

<script>
import { getProductByID, getProductDetailByID } from "@/api";
export default {
  data() {
    return {
      tableData: [
        {
          parameterName: "尺寸",
          data: "φ600*H1477",
        },
        {
          parameterName: "材质",
          data: "	主体合金框架，ABS外壳",
        },
        {
          parameterName: "重量",
          data: "≤100KG",
        },
        {
          parameterName: "扬声器",
          data: "	2.0声道20W",
        },
        {
          parameterName: "工控机",
          data: "		4G/64G/WIFI/Linux",
        },
        {
          parameterName: "通讯方式",
          data: "		WIFI/5G",
        },
        {
          parameterName: "高清摄像头(带麦克风)",
          data: "	1080P自动对焦",
        },
      ],
      dataProduct: {},
    };
  },
  created() {
    this.loadById();
  },
  methods: {
    loadById() {
      let producyId = this.$route.params.id;
      getProductByID(producyId)
        .then((res) => {
          if (res.code === "200") {
            this.tableData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      getProductDetailByID(producyId)
        .then((res) => {
          if (res.code === "200") {
            this.dataProduct = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@media (min-width: 966px) {
  .flexible {
  }
}
.grid-content {
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.19);
  border-radius: 10px;
  position: relative;
  overflow: hidden;
}

.grid-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  transform: rotateX(-1deg) rotateY(-2deg) scale(1.02);
  z-index: -1;
}

.grid-content::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: #ffffff;
  transform: rotateX(1deg) rotateY(2deg) scale(0.98);
  z-index: -1;
}
.right_bottom_1 {
  font-size: 20px;
  text-align: left;
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;
  line-height: 40px;
  border-bottom: 2px solid #333;
}
.des {
  width: 90%;
  margin: 0 auto;
  height: 60%;
  line-height: 45px;
  font-size: 20px;
  text-indent: 2em;
  text-align: left;
  margin-top: 18px;
}
.bottom_all {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
  margin-bottom: 20px;
}
.pho_all {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.con_all {
  display: flex;
  flex-direction: row;
  height: 55px;
  width: auto;
  align-items: center;
  border: 1px solid #333;
  border-radius: 10px;
  background-color: #fff;
  color: #333;
}
.con_all:hover {
  background-color: #333;
  color: #fff;
  cursor: pointer;
}
.contact_us {
  padding-right: 8px;
}
.right_1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.MainOne {
  height: 490px;
}
el-form-item {
  list-style: 56px;
}

.right_letter {
  border-bottom: 2px solid #333;
  text-align: right;
  margin-top: 80px;
}
.contact {
  width: 100%;
  height: auto;
  margin: 0 auto;
  background-color: rgb(243, 245, 245);
}
.MainTwo {
  width: 88%;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 60px;
}
.contact hr {
  color: rgb(136, 126, 126);
}
h2 {
  text-align: right;
  text-align: left;
  color: blue;
  margin-top: 10px;
}
.contact h3 {
  text-align: left;
  color: grey;
  margin-bottom: 60px;
}
</style>
